import type { ExtractPropTypes, PropType, StyleValue } from 'vue'
import type { UseEventBusReturn } from '@vueuse/core'

const optionsKeys = [
  'edit',
  'directory',
  'play',
  'docCtl',
  'annotation',
  'review'
] as const

export type ContentToolbarEvtType = 'setListItemActive'

export type OptionsKeysType = typeof optionsKeys[number]

export type OptionType = {
  active?: boolean
  key: OptionsKeysType
  iconName: string
  label: string
  handler: (...args: any[]) => unknown
}

export const optionsKeysMap = optionsKeys.reduce(
  (pre, cur) => {
    pre[cur as any] = cur
    return pre
  },
  {} as {
    [key in OptionsKeysType]: key
  }
)

const props = {
  containerStyle: {
    type: Object as PropType<StyleValue>,
    default: () => ({})
  },
  showEditBtn: {
    type: Boolean,
    default: true
  },
  showToolbarBtn: {
    type: Boolean,
    default: true
  },
  optionsOrder: {
    type: Array as PropType<Array<OptionsKeysType>>,
    default: () => optionsKeys
  },
  onOptionClick: {
    type: Function as PropType<
      (
        optionKey: OptionsKeysType,
        option: OptionType,
        next: (...args: any[]) => unknown
      ) => unknown
    >,
    default: () => undefined
  },
  onEditBtnClick: {
    type: Function as PropType<(...args: any) => unknown>,
    default: () => undefined
  },
  top: {
    type: String,
    default: 'unset'
  },
  left: {
    type: String,
    default: 'unset'
  },
  right: {
    type: String,
    default: 'unset'
  },
  bottom: {
    type: String,
    default: 'unset'
  },
  evtBus: {
    type: Object as PropType<UseEventBusReturn<ContentToolbarEvtType, unknown>>
  }
}

export type ContentToolbarPropsType = ExtractPropTypes<typeof props>

export default props
